import styled from 'styled-components/macro';
import { Button } from '@la/ds-ui-components';

export const DivisionCardFooter = styled.div`
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DivisionCardCancelButton = styled(Button)`
  position: relative;
  left: -12px;
`;
